import { useReducer } from 'react';

function dataReducer(state, action) {
  const entries = action(state.entries);
  // const sum = entries.reduce((acc, entry) => acc + entry.sum, 0);
  return {
    entries,
    // sum
  };
}

const initialState = {
  entries: [],
  // sum: 0
};

export default function useDataReducer() {
  return useReducer(dataReducer, initialState);
}
